<template>
  <div class="games_left_section">
    <div class="games_left_content">
      <h2>{{ getTranslations.home_games_left_start_new }}</h2>
      <div class="games_left_info">
        <a style="cursor:pointer" @click="gamesLeft"> <p>{{ getTranslations.home_default_content_games_left }}</p>
          <span class="games_left_num">{{ numberFormatting(userDetails.availableGames) }}</span></a></div>
      <div class="buy games_left_info" v-if="!hideStore">
        <a style="cursor:pointer"  @click.prevent="toStorePage"> <p>{{ getTranslations.home_buy_games }}</p>
        </a></div>

      <div class="new_game_buttons_section">
        <div class="btn_left"><p>{{ getTranslations.home_declined_req_random_game }}</p><a style="cursor:pointer" @click="playGame"><img src="static/images/random_icon.svg" alt=""></a></div>
        <div class="btn_right"><p>{{ getTranslations.home_declined_req_choose_another_friend }}</p><a style="cursor:pointer" @click.prevent="goToFavoritePage"><img src="static/images/friend_icon.svg" alt=""></a></div>
      </div>
      <celebrity v-if="!!celebrityInfo"></celebrity>
    </div>
    <component :is="currentGamesLeftModal"  v-if="showModal" @close="showModal = false; "></component>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import GamesLeft from '@/components/home/modals/profile/GamesLeft';
import ZeroBalance from '@/components/home/modals/profile/GamesLeftZeroBalance';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import Celebrity from './Celebrity';

export default {
  name: 'games-left-component',
  props: ['playGame'],
  mixins: [NumbersFormattingMixin],
  components: {
    Celebrity,
    ZeroBalance,
    GamesLeft,
  },
  data() {
    return {
      currentGamesLeftModal: null,
      showModal: false,
    };
  },
  methods: {
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
    ]),
    goToFavoritePage() {
      this.$router.push('/home/favoriteUsers');
    },
    toStorePage() {
      this.$router.push('/home/store');
    },
    gamesLeft() {
      this.showModal = true;
      if (this.userDetails.availableGames > 0) {
        this.currentGamesLeftModal = GamesLeft;
      } else {
        this.currentGamesLeftModal = ZeroBalance;
      }
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
      'getCarouselPrizes',
    ]),
    ...mapState('common', [
      'userDetails',
      'hideStore',
    ]),
    ...mapState('profile', [
      'celebrityInfo',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/GamesLeftComponent.vue